import { api } from './api';


const getCurrentLoadBalance = async ({ customerId, vouId = 1 }) => {

  const response = await api({
    url: `LoadBalances/getCurrentLoadBalance`,
    method: 'GET',
    params: {
      customerId,
      vouId,
    },
  });
  return response.data;
};

const getBusinessDayByMonth = async ({ monthId }) => {
  const response = await api({
    url: `LoadBalances/getWorkingDays`,
    method: 'GET',
    params: {

 month: monthId,

    },
  });
  return response.data;
};

const getPreviousLoadBalance = async (data) => {
  const response = await api({
    url: `LoadBalances/getPreviousLoadBalance`,
    method: 'GET',
    params: data,
  });
  return response.data;
};

const prepareLoadBalance = async (data) => {
  const response = await api({
    url: `LoadBalances/prepareLoadBalance`,
    method: 'POST',
    data,
  });
  return response.data;
};

const getDraftedLoadBalances = async ({ customerId, pageSize, pageNumber }) => {
  const response = await api({
    url: `LoadBalances/getDraftedLoadBalances`,
    method: 'GET',
    params: {
      customerId,
      pageSize,
      page: pageNumber,
    },
  });
  return response.data;
};

const loadBalancesSave = async (data) => {
  const response = await api({
    url: `LoadBalances`,
    method: 'POST',
    data,
  });
  return response.data;
};

const loadBalancesUpdate = async (data) => {
  const response = await api({
    url: `LoadBalances/order`,
    method: 'POST',
    data: {
      ...data.entity,
      sendMail: data.sendMail,
    },
  });
  return response.data;
};

const loadBalancesDelete = async ({ id, CancelledByUser }) => {
  const response = await api({
    url: `LoadBalances`,
    method: 'DELETE',
    data: {
      id,
      CancelledByUser,
    },
  });
  return response.data;
};

const getById = async ({ id }) => {
  const response = await api({
    url: `LoadBalances/getbyid`,
    method: 'GET',
    params: {
      id,
    },
  });
  return response.data;
};

const copyLoadBalance = async (data) => {
  const response = await api({
    url: `LoadBalances/copyLoadBalance`,
    method: 'POST',
    data,
  });
  return response.data;
};

const getLoadBalanceForThanksPage = async (id, provisionDay, vouId) => {
  const response = await api({
    url: `LoadBalances/getLoadBalanceForThanksPage`,
    method: 'GET',
    params: {
      id,
      orderProvisionDate: provisionDay,
      vouId,
    },
  });
  return response.data;
};

const getLoadBalancesForStatusWithUpdaterUserName = async ({ data }) => {
  const response = await api({
    url: `LoadBalances/GetLoadBalancesForStatusWithUpdaterUserName`,
    method: 'GET',
    params: {
      page: data?.pageNumber,
      ...data,
    },
  });
  return response.data;
};

const putSubTypeReport = async (data) => {
  const response = await api({
    url: `LoadBalances/subtype`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const getOrderDoubleCheck = async (data) => {
  const response = await api({
    url: `LoadBalances/getOrderDoubleCheck`,
    method: 'GET',
    params: data,
  });

return response.data;

};

const balanceUploadServices = {
    getCurrentLoadBalance,
    getPreviousLoadBalance,
    getDraftedLoadBalances,
    prepareLoadBalance,
    loadBalancesSave,
    loadBalancesUpdate,
    loadBalancesDelete,
    getById,
    copyLoadBalance,
    getLoadBalanceForThanksPage,
    getLoadBalancesForStatusWithUpdaterUserName,
    getBusinessDayByMonth,
    putSubTypeReport,
    getOrderDoubleCheck,
};

export default balanceUploadServices;
